import { DoubleSide, MeshStandardMaterial } from "three";

export const getRawAluminumMaterial = () => {
  return new MeshStandardMaterial({
    color: "#ffffff",
    metalness: 0.9,
    roughness: 0.15,
    envMapIntensity: 0.9,
    side: DoubleSide,
  });
};

export const AluminumMaterial = () => {
  return (
    <meshStandardMaterial
      color="#ffffff"
      metalness={0.9}
      roughness={0.15}
      envMapIntensity={0.9}
      side={DoubleSide}
    />
  );
};
